<div class="dt-main">
  <app-sidebar></app-sidebar>
  <div class="dt-content-wrapper">
    <div class="dt-content">
      <div class="col-md-12 spc-padding d-flex flex-column midbxCol">
        <h2 class="pageHeading">
          <span class="main-chevron">
            <a routerLink="/insights">
              <svg
                width="10"
                height="15"
                viewBox="0 0 10 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.666748 7.5L7.91675 14.75L9.6205 13.0463L4.08633 7.5L9.6205 1.95375L7.91675 0.250003L0.666748 7.5Z"
                  fill="#0D1758"
                ></path>
              </svg>
            </a>
          </span>
          Equipment Health
        </h2>

        <div class="card bggrey tabs-container flex-grow-1">
          <div>
            <svg
              width="1032"
              height="48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="100%"
                height="48"
                rx="6"
                fill="white"
              />
              <g clip-path="url(#clip0_6629_5925)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M25.1 14.9996C25.1 13.9526 25.9529 13.0996 27 13.0996H33C34.047 13.0996 34.9 13.9526 34.9 14.9996V22.9996C34.9 24.0467 34.047 24.8996 33 24.8996H27C25.9529 24.8996 25.1 24.0467 25.1 22.9996V14.9996ZM26.9301 14.9298C26.9093 14.9506 26.9 14.9749 26.9 14.9996V22.9996C26.9 23.0243 26.9093 23.0486 26.9301 23.0695C26.951 23.0903 26.9753 23.0996 27 23.0996H33C33.0247 23.0996 33.049 23.0903 33.0698 23.0695C33.0907 23.0486 33.1 23.0243 33.1 22.9996V14.9996C33.1 14.9749 33.0907 14.9506 33.0698 14.9298C33.049 14.9089 33.0247 14.8996 33 14.8996H27C26.9753 14.8996 26.951 14.9089 26.9301 14.9298ZM37.1 14.9996C37.1 13.9526 37.9529 13.0996 39 13.0996H45C46.047 13.0996 46.9 13.9526 46.9 14.9996V18.9996C46.9 20.0467 46.047 20.8996 45 20.8996H39C37.9529 20.8996 37.1 20.0467 37.1 18.9996V14.9996ZM38.9301 14.9298C38.9093 14.9506 38.9 14.9749 38.9 14.9996V18.9996C38.9 19.0243 38.9093 19.0486 38.9301 19.0695C38.951 19.0903 38.9753 19.0996 39 19.0996H45C45.0247 19.0996 45.049 19.0903 45.0698 19.0695C45.0907 19.0486 45.1 19.0243 45.1 18.9996V14.9996C45.1 14.9749 45.0907 14.9506 45.0698 14.9298C45.049 14.9089 45.0247 14.8996 45 14.8996H39C38.9753 14.8996 38.951 14.9089 38.9301 14.9298ZM37.1 24.9996C37.1 23.9526 37.9529 23.0996 39 23.0996H45C46.047 23.0996 46.9 23.9526 46.9 24.9996V32.9996C46.9 34.0467 46.047 34.8996 45 34.8996H39C37.9529 34.8996 37.1 34.0467 37.1 32.9996V24.9996ZM38.9301 24.9298C38.9093 24.9506 38.9 24.9749 38.9 24.9996V32.9996C38.9 33.0243 38.9093 33.0486 38.9301 33.0695C38.951 33.0903 38.9753 33.0996 39 33.0996H45C45.0247 33.0996 45.049 33.0903 45.0698 33.0695C45.0907 33.0486 45.1 33.0243 45.1 32.9996V24.9996C45.1 24.9749 45.0907 24.9506 45.0698 24.9298C45.049 24.9089 45.0247 24.8996 45 24.8996H39C38.9753 24.8996 38.951 24.9089 38.9301 24.9298ZM25.1 28.9996C25.1 27.9526 25.9529 27.0996 27 27.0996H33C34.047 27.0996 34.9 27.9526 34.9 28.9996V32.9996C34.9 34.0467 34.047 34.8996 33 34.8996H27C25.9529 34.8996 25.1 34.0467 25.1 32.9996V28.9996ZM26.9301 28.9298C26.9093 28.9506 26.9 28.9749 26.9 28.9996V32.9996C26.9 33.0243 26.9093 33.0486 26.9301 33.0695C26.951 33.0903 26.9753 33.0996 27 33.0996H33C33.0247 33.0996 33.049 33.0903 33.0698 33.0695C33.0907 33.0486 33.1 33.0243 33.1 32.9996V28.9996C33.1 28.9749 33.0907 28.9506 33.0698 28.9298C33.049 28.9089 33.0247 28.8996 33 28.8996H27C26.9753 28.8996 26.951 28.9089 26.9301 28.9298Z"
                  fill="#6285FB"
                />
              </g>
              <g clip-path="url(#clip1_6629_5925)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M80 33.668C85.3395 33.668 89.668 29.3395 89.668 24C89.668 18.6605 85.3395 14.332 80 14.332C74.6605 14.332 70.332 18.6605 70.332 24C70.332 29.3395 74.6605 33.668 80 33.668ZM80 35.25C86.2132 35.25 91.25 30.2132 91.25 24C91.25 17.7868 86.2132 12.75 80 12.75C73.7868 12.75 68.75 17.7868 68.75 24C68.75 30.2132 73.7868 35.25 80 35.25Z"
                  fill="#AFB6CE"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M84.597 16.0256L88.3085 23.7759H90.8984V25.4019H87.2843L84.7918 20.197L80.4829 31.8824L76.0087 23.3889L75.2585 24.813H71.9323L69.3221 22.8877L70.2873 21.5791L72.4671 23.187H74.2773L76.0087 19.9002L80.2202 27.895L84.597 16.0256Z"
                  fill="#AFB6CE"
                />
              </g>
              <path
                d="M126.351 17.3427L115.347 28.3593C115.291 28.4149 115.252 28.4844 115.232 28.5605L114.013 33.4614C113.995 33.5341 113.996 33.6102 114.016 33.6824C114.036 33.7546 114.074 33.8204 114.127 33.8734C114.208 33.9544 114.318 33.9999 114.433 34C114.468 34 114.503 33.9956 114.538 33.987L119.433 32.7658C119.509 32.7466 119.579 32.7071 119.634 32.6515L130.64 21.6356L126.351 17.3427ZM133.366 15.8406L132.141 14.6144C131.322 13.7948 129.895 13.7956 129.077 14.6144L127.577 16.1165L131.865 20.4092L133.366 18.9072C133.775 18.498 134 17.9533 134 17.374C134 16.7947 133.775 16.25 133.366 15.8406Z"
                fill="#AFB6CE"
              />
              <path
                d="M168 35C169.319 35 170.455 34.2034 170.953 33.0664H165.047C165.546 34.2034 166.681 35 168 35ZM174.66 23.6503V22.2383C174.66 19.2381 172.666 16.6953 169.934 15.8647V14.9336C169.934 13.8674 169.066 13 168 13C166.934 13 166.066 13.8674 166.066 14.9336V15.8647C163.334 16.6953 161.34 19.2381 161.34 22.2383V23.6503C161.34 26.2857 160.335 28.7846 158.511 30.6867C158.424 30.7779 158.365 30.8927 158.343 31.017C158.32 31.1413 158.334 31.2695 158.384 31.3857C158.433 31.5019 158.516 31.601 158.621 31.6706C158.727 31.7403 158.85 31.7774 158.977 31.7773H177.024C177.15 31.7773 177.273 31.7402 177.379 31.6706C177.484 31.601 177.567 31.5019 177.616 31.3857C177.666 31.2695 177.68 31.1413 177.658 31.017C177.635 30.8928 177.576 30.7779 177.489 30.6867C175.665 28.7846 174.66 26.2856 174.66 23.6503ZM168.645 15.6094C168.432 15.589 168.217 15.5781 168 15.5781C167.783 15.5781 167.568 15.589 167.356 15.6094V14.9336C167.356 14.5782 167.645 14.2891 168 14.2891C168.355 14.2891 168.645 14.5782 168.645 14.9336V15.6094ZM176.379 22.2383C176.379 22.5942 176.668 22.8828 177.024 22.8828C177.379 22.8828 177.668 22.5942 177.668 22.2383C177.668 19.6559 176.662 17.228 174.836 15.402C174.585 15.1503 174.177 15.1502 173.925 15.402C173.673 15.6537 173.673 16.0617 173.925 16.3134C175.507 17.896 176.379 20.0002 176.379 22.2383ZM158.977 22.8828C159.333 22.8828 159.621 22.5942 159.621 22.2383C159.621 20.0002 160.493 17.8961 162.075 16.3135C162.327 16.0618 162.327 15.6537 162.075 15.402C161.824 15.1503 161.416 15.1503 161.164 15.402C159.338 17.228 158.332 19.6559 158.332 22.2383C158.332 22.5942 158.621 22.8828 158.977 22.8828Z"
                fill="#AFB6CE"
              />
              <defs>
                <clipPath id="clip0_6629_5925">
                  <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="translate(24 12)"
                  />
                </clipPath>
                <clipPath id="clip1_6629_5925">
                  <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="translate(68 12)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
          <ul
            ngbNav
            #nav="ngbNav"
            [(activeId)]="active"
            class="nav-tabs"
          >
            <li
              ng-disabled="true"
              [ngbNavItem]="1"
            >
              <a ngbNavLink>Inventory</a>
              <ng-template ngbNavContent>
                <div class="customScroll2 inventory_col">
                  <div
                    class="panelHeading headerClass d-flex align-items-center"
                  >
                    <div style="width: 40%">Panels</div>
                    <div class="flex-grow-1"></div>
                    <div class="me-4">Sort By:</div>
                    <div class="sortOptions">
                      <label>
                        <input
                          id="radioPanelNonConnected"
                          type="radio"
                          name="nonConnected"
                          (click)="radioMainEdit($event)"
                          [checked]="panelnonConnected"
                        />
                        Non-Connected
                      </label>
                    </div>
                    <div class="sortOptions">
                      <label>
                        <input
                          id="radioPanelNonActive"
                          type="radio"
                          name="nonActive"
                          (click)="radioMainEdit($event)"
                          [checked]="panelnonActive"
                        />
                        Non-Active
                      </label>
                    </div>
                    <div class="sortOptions">
                      <label>
                        <input
                          id="radioPanelActive"
                          type="radio"
                          name="active"
                          (click)="radioMainEdit($event)"
                          [checked]="panelactive"
                        />
                        Active
                      </label>
                    </div>
                    <div class="sortOptions">
                      <label>
                        <input
                          id="radioPanelAll"
                          type="radio"
                          name="all"
                          (click)="radioMainEdit($event)"
                          [checked]="panelall"
                        />
                        All
                      </label>
                    </div>
                  </div>
                  <div
                    *ngFor="
                      let circuitCategory of circuitCategoryMain;
                      let i = index
                    "
                  >
                    <div class="panelRow panelHeading customPanelRow">
                      <div class="panelRunning">
                        <div class="colorbx">
                          <span
                            class="design"
                            [ngStyle]="{ background: circuitCategory.colour }"
                          ></span>
                        </div>
                        <div
                          class="heading"
                          [ngStyle]="{
                            color: circuitCategory.Isconnected
                              ? '#1fab3d'
                              : 'grey'
                          }"
                        >
                          {{ circuitCategory.name }}
                        </div>
                        <div
                          class="traingle"
                          id="arrow"
                          [attr.aria-expanded]="isInventryCollapsed[i]"
                          (click)="collapse.toggle()"
                          aria-controls="collapseExample"
                        ></div>
                        <div class="info">
                          <a
                            href="javascript: void(0);"
                            aria-disabled="false"
                            [attr.id]="circuitCategory.name"
                          >
                            <svg
                              fill="#B0BFE5"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="18px"
                              height="18px"
                            >
                              <path
                                d="M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 7 L 11 9 L 13 9 L 13 7 L 11 7 z M 11 11 L 11 17 L 13 17 L 13 11 L 11 11 z"
                              ></path>
                            </svg>
                          </a>
                        </div>
                        <!-- <div *ngIf="circuitCategory.panelIsconnected" class="heading">
                          <span  [ngStyle]="{'color' : '#1fab3d'  }">{{panel.active_circuits}} circuits monitored </span>/ {{panel.panel_circuits.length}} circuits total
                        </div>
                        <div *ngIf="!circuitCategory.panelIsconnected" class="heading" [ngStyle]="{'color' : 'grey' }">
                          Disconnected
                        </div> -->
                      </div>
                    </div>
                    <div
                      #collapse="ngbCollapse"
                      [(ngbCollapse)]="isInventryCollapsed[i]"
                      class="panelShow"
                    >
                      <div
                        class="panelList panelList-cutom"
                        *ngFor="let circuit of circuitCategory.circuit_set"
                      >
                        <div
                          class="panelName"
                          [ngStyle]="{
                            color: circuit.is_monitored ? '#1fab3d' : '#FF7F27'
                          }"
                        >
                          <span
                            class="circle"
                            [ngStyle]="{
                              color: circuit.is_monitored
                                ? '#1fab3d'
                                : '#FF7F27'
                            }"
                          ></span>
                          {{ circuit.circuit_name }}
                        </div>

                        <div
                          class="panelPercentage"
                          *ngIf="circuit.is_monitored"
                        >
                          Active / Monitoring Equipment Health
                        </div>
                        <div
                          class="panelPercentage"
                          *ngIf="!circuit.is_monitored"
                          style="color: #ff7f27"
                        >
                          Active / Not Monitoring
                        </div>
                        <div class="form-check form-switch">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [ngStyle]="{
                              'background-color': circuit.is_monitored
                                ? '#1fab3d'
                                : '#E04A41'
                            }"
                            role="switch"
                            id="flexSwitchCheckChecked"
                            [checked]="circuit.is_monitored"
                            (click)="circuit_monitor_toggle($event, circuit)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="2">
              <a ngbNavLink>Panels</a>
              <ng-template ngbNavContent>
                <div class="customScroll2">
                  <div class="panelHeading headerClass">
                    <div style="width: 40%">Panels</div>
                    <div class="flex-grow-1"></div>
                    <div class="me-4">Sort By:</div>
                    <div class="sortOptions">
                      <label>
                        <input
                          id="radioPanelNonConnected"
                          type="radio"
                          name="nonConnected"
                          (click)="radioMainEdit($event)"
                          [checked]="panelnonConnected"
                        />
                        Non-Connected
                      </label>
                    </div>
                    <div class="sortOptions">
                      <label>
                        <input
                          id="radioPanelNonActive"
                          type="radio"
                          name="nonActive"
                          (click)="radioMainEdit($event)"
                          [checked]="panelnonActive"
                        />
                        Non-Active
                      </label>
                    </div>
                    <div class="sortOptions">
                      <label>
                        <input
                          id="radioPanelActive"
                          type="radio"
                          name="active"
                          (click)="radioMainEdit($event)"
                          [checked]="panelactive"
                        />
                        Active
                      </label>
                    </div>
                    <div class="sortOptions">
                      <label>
                        <input
                          id="radioPanelAll"
                          type="radio"
                          name="all"
                          (click)="radioMainEdit($event)"
                          [checked]="panelall"
                        />
                        All
                      </label>
                    </div>
                  </div>
                  <div *ngFor="let panel of panels; let i = index">
                    <div class="panelRow panelHeading customPanelRow">
                      <div class="panelRunning">
                        <div class="greybx">
                          <span
                            [ngClass]="panel.panelIsconnected ? 'green' : 'red'"
                          ></span>
                        </div>
                        <div
                          class="heading"
                          [ngStyle]="{
                            color: panel.panelIsconnected ? '#1fab3d' : 'grey'
                          }"
                        >
                          {{ panel.panel_name }}
                        </div>
                        <div
                          class="traingle"
                          id="arrow"
                          [attr.aria-expanded]="isPanelCollapsed[i]"
                          (click)="collapse.toggle()"
                          aria-controls="collapseExample"
                        ></div>
                        <div class="info">
                          <a
                            href="javascript: void(0);"
                            aria-disabled="false"
                            [attr.id]="panel.panel_name"
                          >
                            <svg
                              fill="#ccc"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="18px"
                              height="18px"
                            >
                              <path
                                d="M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 7 L 11 9 L 13 9 L 13 7 L 11 7 z M 11 11 L 11 17 L 13 17 L 13 11 L 11 11 z"
                              ></path>
                            </svg>
                          </a>
                        </div>
                        <a
                          href="javascript: void(0);"
                          aria-disabled="false"
                          [attr.id]="panel.panel_name"
                        >
                          <img
                            src="assets/images/Vector.png"
                            alt="arrow"
                          />
                        </a>
                      </div>
                      <div
                        *ngIf="panel.panelIsconnected"
                        class="heading"
                      >
                        <span [ngStyle]="{ color: '#1fab3d' }"
                          >{{ panel.active_circuits }} circuits monitored </span
                        >/ {{ panel.panel_circuits.length }} circuits total
                      </div>
                      <div
                        *ngIf="!panel.panelIsconnected"
                        class="heading"
                        [ngStyle]="{ color: 'grey' }"
                      >
                        Disconnected
                      </div>
                    </div>
                    <div
                      #collapse="ngbCollapse"
                      [(ngbCollapse)]="isPanelCollapsed[i]"
                      class="panelShow"
                    >
                      <div
                        class="panelList panelList-cutom"
                        *ngFor="let circuit of panel.panel_circuits"
                      >
                        <div
                          class="panelName"
                          [ngStyle]="{
                            color: circuit.is_monitored ? '#1fab3d' : '#FF7F27'
                          }"
                        >
                          <span
                            class="circle"
                            [ngStyle]="{
                              color: circuit.is_monitored
                                ? '#1fab3d'
                                : '#FF7F27'
                            }"
                          ></span>
                          {{ circuit.circuit_name }}
                        </div>

                        <div
                          class="panelPercentage"
                          *ngIf="circuit.is_monitored"
                        >
                          Active / Monitoring Equipment Health
                        </div>
                        <div
                          class="panelPercentage"
                          *ngIf="!circuit.is_monitored"
                          style="color: #ff7f27"
                        >
                          Active / Not Monitoring
                        </div>
                        <div class="form-check form-switch">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [ngStyle]="{
                              'background-color': circuit.is_monitored
                                ? '#1fab3d'
                                : '#E04A41'
                            }"
                            role="switch"
                            id="flexSwitchCheckChecked"
                            [checked]="circuit.is_monitored"
                            (click)="circuit_monitor_toggle($event, circuit)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="3">
              <a ngbNavLink>Circuits</a>
              <ng-template ngbNavContent>
                <div class="customScroll2">
                  <div class="panelHeading headerClass">
                    <div style="width: 40%">Panels</div>
                    <div class="flex-grow-1"></div>
                    <div class="me-4">Sort By:</div>
                    <div class="sortOptions">
                      <label>
                        <input
                          id="radioPanelNonConnected"
                          type="radio"
                          name="nonConnected"
                          (click)="radioMainEdit($event)"
                          [checked]="panelnonConnected"
                        />
                        Non-Connected
                      </label>
                    </div>
                    <div class="sortOptions">
                      <label>
                        <input
                          id="radioPanelNonActive"
                          type="radio"
                          name="nonActive"
                          (click)="radioMainEdit($event)"
                          [checked]="panelnonActive"
                        />
                        Non-Active
                      </label>
                    </div>
                    <div class="sortOptions">
                      <label>
                        <input
                          id="radioPanelActive"
                          type="radio"
                          name="active"
                          (click)="radioMainEdit($event)"
                          [checked]="panelactive"
                        />
                        Active
                      </label>
                    </div>
                    <div class="sortOptions">
                      <label>
                        <input
                          id="radioPanelAll"
                          type="radio"
                          name="all"
                          (click)="radioMainEdit($event)"
                          [checked]="panelall"
                        />
                        All
                      </label>
                    </div>
                  </div>
                  <div
                    *ngFor="
                      let circuitCategory of circuitCategoryMain;
                      let i = index
                    "
                  >
                    <div
                      class="panelList panelList-cutom"
                      *ngFor="let circuit of circuitCategory.circuit_set"
                    >
                      <div
                        class="panelName"
                        [ngStyle]="{
                          color: circuit.is_monitored ? '#1fab3d' : '#FF7F27'
                        }"
                      >
                        <span
                          class="circle"
                          [ngStyle]="{
                            color: circuit.is_monitored ? '#1fab3d' : '#FF7F27'
                          }"
                        ></span>
                        {{ circuit.circuit_name }}
                      </div>

                      <div
                        class="panelPercentage"
                        *ngIf="circuit.is_monitored"
                      >
                        Active / Monitoring Equipment Health
                      </div>
                      <div
                        class="panelPercentage"
                        *ngIf="!circuit.is_monitored"
                        style="color: #ff7f27"
                      >
                        Active / Not Monitoring
                      </div>
                      <div class="form-check form-switch">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          [ngStyle]="{
                            'background-color': circuit.is_monitored
                              ? '#1fab3d'
                              : '#E04A41'
                          }"
                          role="switch"
                          id="flexSwitchCheckChecked"
                          [checked]="circuit.is_monitored"
                          (click)="circuit_monitor_toggle($event, circuit)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </li>
          </ul>
          <div
            [ngbNavOutlet]="nav"
            class="mt-2"
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>
